import API from './axios';

// Earnings Management API Service
export const earningsService = {
  // Get all earnings data with filters
  getAllEarnings: async (params = {}) => {
    const { period = 'week', driverId, startDate, endDate } = params;
    const queryParams = new URLSearchParams({
      period,
      ...(driverId && { driverId }),
      ...(startDate && { startDate }),
      ...(endDate && { endDate })
    });

    const response = await API.get(`/admin/earnings?${queryParams}`);
    return response.data;
  },

  // Get earnings for a specific driver
  getDriverEarnings: async (driverId, params = {}) => {
    const { period = 'week' } = params;
    const queryParams = new URLSearchParams({ period });
    
    const response = await API.get(`/admin/earnings/drivers/${driverId}?${queryParams}`);
    return response.data;
  },

  // Process payments for drivers
  processPayments: async (paymentData) => {
    const response = await API.post('/admin/earnings/process', paymentData);
    return response.data;
  },

  // Get earnings analytics
  getEarningsAnalytics: async (params = {}) => {
    const { period = 'month', startDate, endDate } = params;
    const queryParams = new URLSearchParams({
      period,
      ...(startDate && { startDate }),
      ...(endDate && { endDate })
    });

    const response = await API.get(`/admin/earnings/analytics?${queryParams}`);
    return response.data;
  },

  // Get earnings summary for dashboard
  getEarningsSummary: async (period = 'week') => {
    const response = await API.get(`/admin/earnings?period=${period}`);
    return response.data;
  }
};

export default earningsService;
